import { db } from "../../../config/firebaseconfig";

export default function getAllDistrictAdmins (district, updateState) {
  updateState({loadingAdmins: true})
  return db.collection('educators')
    .where('role', '==', 'District Admin')
    .where('schoolDistrict', '==', district)
    .onSnapshot(querySnapshot => {
      let districtAdmins = []
      querySnapshot.forEach((doc) => {
        if (doc.exists) {
          const data = doc.data()
          if (!data.deleted) districtAdmins.push(data)
        }
      })
      return updateState({loadingAdmins: false, admins: districtAdmins})
    }, error => 
      updateState({
        loadingAdmins: false, 
        errorAdmins: error, 
        admins: null
      }))



    /*.get()
    .then((querySnapshot) => {
      let districtAdmins = []
      querySnapshot.forEach((doc) => {
        if (doc.exists) {
          const data = doc.data()
          if (!data.deleted) districtAdmins.push(data)
        }
      })
      return updateState({loadingAdmins: false, admins: districtAdmins})
    })
    .catch(error => updateState({loadingAdmins: false, errorAdmins: error, admins: null}))
    */
}


// WEBPACK FOOTER //
// ./src/helpers/users/licenses/getAllDistrictAdmins.js